<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useForm, useField } from 'vee-validate'
import {
  KkTextField,
  KkValidationError,
  KkLoading,
  KkFormLabel,
  KkBox,
} from '../components/base'
const store = useStore()
const router = useRouter()
const { t } = useI18n()
const { company_uuid, sns_category_id } = useRoute().params
const snsCategory = computed(() => store.state.companiesSnsCategory.data)
const snsCategoryLoading = computed(() => store.state.companiesSnsCategory.loading)
const readSnsCategory = () => store.dispatch('companiesSnsCategory/readSnsCategory', sns_category_id)
const createSnsCategory = (payload) => store.dispatch('companiesSnsCategory/createSnsCategory', payload)
const updateSnsCategory = (snsCategoryId, payload) => store.dispatch('companiesSnsCategory/updateSnsCategory', { snsCategoryId, payload })
const schema = {
  name: 'required',
}

const { handleSubmit, meta, setValues } = useForm({
  validationSchema: schema,
  initialValues: {
    name: '',
  },
})
const { value: name, errorMessage: nameError, handleChange: nameHandleChange } = useField('name', undefined, { label: t('pages.companies.snsCategoryForm.name') })

const handleSave = handleSubmit(async (value) => {
  const payload = {
    sns_category: {
      name: value.name,
    }
  }
  const isSuccess = sns_category_id ? await updateSnsCategory(sns_category_id, payload) : await createSnsCategory(payload)
  if(isSuccess) router.push({ name: 'CompaniesManagementSnsCategories', params: { company_uuid: company_uuid } })
})

const load = async () => {
  await readSnsCategory()
  setValues({
    name: snsCategory.value.name,
  })
}
if(sns_category_id) load()
</script>
<template>
  <KkBox>
    <template #content>
      <KkLoading v-if="snsCategoryLoading" />
      <div v-else>
        <div class="filed">
          <KkFormLabel class="c-formLabel" :text="$t('models.snsCategory.modelName')" />
          <KkTextField :model-value="name" class="c-textField" :placeholder="$t('pages.companies.snsCategoryForm.placeholder')" @update:model-value="nameHandleChange" />
          <KkValidationError :text="nameError" />
        </div>
      </div>
    </template>
    <template #footer>
      <div class="c-button c-button--right">
        <router-link class="c-button__item c-button__item--outline-cancel" :to="{ name: 'CompaniesManagementSnsCategories', params: { company_uuid: company_uuid } }">{{ $t('labels.cancel') }}</router-link>
        <button
          class="c-button__item c-button__item--primary"
          :class="{'c-button__item--disabled': !meta.valid}"
          :disabled="!meta.valid"
          @click="handleSave"
        >
          {{ $t('labels.confirm') }}
        </button>
      </div>
    </template>
  </KkBox>
</template>
